export default __webpack_public_path__ + "static/article-finance-in-search-of-the-well-rounded-lifestyle-4a4318fd9e48f8f4c1fceb02d632c1fa.jpg";